import React from 'react';
import { Paper, Button } from '@material-ui/core';
import { useLogoutButtonStyles } from './styles';
import CloseIcon from '../../common/icons/closeIcon';
import { goOut } from '../../../helpers/AuthenticationHelper';

const LogoutButton = () => {
  const classes = useLogoutButtonStyles();
  return (
    <Paper className={classes.container}>
      <Button
        variant="text"
        className={classes.button}
        endIcon={<CloseIcon size="30px" />}
        onClick={goOut}
      >
        Cerrar Sesión
      </Button>
    </Paper>
  );
};

export default LogoutButton;
